// extracted by mini-css-extract-plugin
module.exports = {"container":"LoadingSkeleton_container___7vIj","shimmer":"LoadingSkeleton_shimmer__1sAX-"};